import { Bucket } from './bucketModel';

export function applyToBucket<TBucket extends Bucket>(
    buckets: TBucket[],
    value: number
): TBucket | null {
    return buckets.find((item) => item.lower <= value && value <= item.upper) ?? null;
}
